import React, { useState, useEffect } from 'react';
import { pageService } from '../services/api';

const HistorySection = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const response = await pageService.getPageBySlug('briefHistoryExaminationBranch');
        setContent(response?.data?.page || null);
      } catch (err) {
        console.error('Failed to load history section:', err);
        setContent(null);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading || !content) return null;

  return (
    <div className="col-md-6 width-44" id="briefHistoryExaminationBranch">
      <h2 className="secondary-title">{content.title}</h2>
      {content.sidebar_content && (
        <div className="img-wrapper">
          <img src={`/uploads/${content.sidebar_content}`} alt={content.title} className="img-fluid" />
        </div>
      )}
      <div dangerouslySetInnerHTML={{ __html: content.content }} />
    </div>
  );
};

export default HistorySection;
